'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 *  Dependency: components/_scroll.scss
 *
 *
 */

var dom = {
  header: 'header',
  scrollBody: 'html, body',
  scrollTo: '[scroll-to]',
  scrollPosition: '[scroll-position]'
};

var scrollPosition = window.pageYOffset;

var bodyLock = function bodyLock() {
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = '-' + scrollPosition + 'px';
  document.body.style.width = '100%';
};

var bodyUnlock = function bodyUnlock() {
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('position');
  document.body.style.removeProperty('top');
  document.body.style.removeProperty('width');
};

var returnToScrollPosition = function returnToScrollPosition() {
  return window.scrollTo(0, scrollPosition);
};

var lock = exports.lock = function lock(menuName) {
  // Previous solution maintained for backup as the new solution is experiemental
  // Reference: https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
  // document.body.style.top = `${window.scrollY}px`;
  // document.body.classList.add('no-scroll');

  // Reference: https://markus.oberlehner.net/blog/simple-solution-to-prevent-body-scrolling-on-ios/
  // Set timeout allows time for scrollPosition to be calculated before the dom changes, otherwise always returns 0
  scrollPosition = window.pageYOffset;
  setTimeout(bodyLock, 0);
};

var unlock = exports.unlock = function unlock(menuName) {
  // Previous solution maintained for backup as the new solution is experiemental
  // Reference: https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
  // const top = parseInt(document.body.style.top.replace('px', ''), 10);
  // document.body.classList.remove('no-scroll');
  // document.body.style.top = '';
  // window.scrollTo(0, top);

  // Reference: https://markus.oberlehner.net/blog/simple-solution-to-prevent-body-scrolling-on-ios/
  // Set timeout allows dom changes to happen before calculating appling scrollPosition
  bodyUnlock();
  setTimeout(returnToScrollPosition, 0);
};

var toggle = exports.toggle = function toggle(menuName) {
  $(dom.scrollBody).toggleClass('no-scroll');
};

var smoothScroll = exports.smoothScroll = function smoothScroll(targetName) {
  var $target = $(dom.scrollPosition).filter('[scroll-position="' + targetName + '"]');
  if (!$target.length) $target = $('[id="' + targetName + '"]');
  if (!$target.length) return;
  var headerHeight = $(dom.header).outerHeight();
  if (window.innerWidth <= 992 && headerHeight > 90) headerHeight = 90; // remove height from primary menu that auto-hides itself
  var scrollOffset = $target.offset().top - headerHeight;
  $(dom.scrollBody).animate({ scrollTop: scrollOffset }, 300);
  // Move focus down to scrolled elements
  var $targetFocusElement = $target.find('a, button').eq(0);
  if ($targetFocusElement.length) $targetFocusElement.trigger('focus');
};

var scrollToHandler = function scrollToHandler(event) {
  event.preventDefault();
  var $this = $(event.currentTarget);
  var targetName = $this.attr('scroll-to');
  smoothScroll(targetName);
};

var bindUIActions = function bindUIActions() {
  $(dom.scrollTo).on('click', scrollToHandler);
};

var init = exports.init = function init() {
  bindUIActions();
  console.log('[BVA] Component Loaded: Scroll');
};